import React, { useState, useEffect, useContext, useCallback } from 'react';
import Navbar from "../../../Shared/Sales-ExecutiveNavbar/Navbar";
import { Table, Select, Button, DatePicker, InputNumber, Input, Modal, Form, Card, Tag, Space, Spin, message } from 'antd';
import { CloseOutlined, FilterOutlined } from '@ant-design/icons';
import axios from 'axios';
import 'antd/dist/reset.css';
import { baseURL } from "../../../Apiservices/Api";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from '../../../AuthContext/AuthContext';
import { useQuery } from '@tanstack/react-query';
import * as XLSX from 'xlsx';
import ReportComments from '../../../../Components/Pages/Admin/Report/ReportComments'; 
import "./Report.css";
import dayjs from 'dayjs';
const { Option } = Select;
const { RangePicker } = DatePicker;

// Field definitions based on API response
const allFields = [
  { key: 'leadid', label: 'Lead ID', type: 'text' },
  { key: 'name', label: 'Name', type: 'text' },
  { key: 'email', label: 'Email', type: 'text' },
  { key: 'country_code', label: 'Country Code', type: 'text' },
  { key: 'phone_number', label: 'Phone', type: 'text' },
  { key: 'status', label: 'Status', type: 'text' },
  { key: 'primaryStatus', label: 'Primary Status', type: 'text' },  
  { key: 'secondaryStatus', label: 'Secondary Status', type: 'text' },
  { key: 'primarySource', label: 'Primary Source', type: 'text' },
  { key: 'secondarysource', label: 'Secondary Source', type: 'text' },
  { key: 'destination', label: 'Destination', type: 'text' },
        { key: 'origincity', label: 'Origin City', type: 'text' },

  { key: 'assign_to_manager', label: 'Manager', type: 'text' },
  { key: 'assignedSalesName', label: 'Associate', type: 'text' },
  { key: 'description', label: 'Description', type: 'text' },
  { key: 'tag_names', label:'Tag', type: 'text' }, 
 { key: 'comment', label: 'Comment', type: 'date' },
  { key: 'created_at', label: 'Created At', type: 'date' },
  { key: 'updated_at', label: 'Updated At', type: 'date' },
  
];

const S_ReportBuilder = () => {
  const navigate = useNavigate();
  const { authToken, userId, userRole } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("reportleads");
  const [collapsed, setCollapsed] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFields, setSelectedFields] = useState(['name', 'email', 'phone_number', 'status',]);
  const [activeFilters, setActiveFilters] = useState([]);
  const [availableFilterFields, setAvailableFilterFields] = useState([]);
  const [selectedFilterField, setSelectedFilterField] = useState(null);
  const [savedReports, setSavedReports] = useState([]);
  const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
  const [reportName, setReportName] = useState('');
  const [reportDescription, setReportDescription] = useState('');
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSavedReports, setShowSavedReports] = useState(false);
  const [commentDates, setCommentDates] = useState({});
  
  // Add these new state variables for comments
  const [selectedLeadForComments, setSelectedLeadForComments] = useState(null);
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [commentCounts, setCommentCounts] = useState({});

  // Load saved reports from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('savedLeadReports');
    if (saved) {
      setSavedReports(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    const fetchSavedReports = async () => {
      if (!userId) return; // Skip if no userId

      try {
        const response = await axios.get(`${baseURL}/api/users/${userId}/reports`);
        const oppReports = response.data.filter(report => report.type == "Lead");
        setSavedReports(oppReports);
      } catch (error) {
        message.error('Failed to fetch saved reports');
        console.error('Error fetching user reports:', error);

        // Fallback to local storage if API fails
        const localReports = JSON.parse(localStorage.getItem('savedLeadReports') || '[]');
        const oppLocalReports = localReports.filter(
          report => report.userId == userId && report.type == "Lead"
        );
        setSavedReports(oppLocalReports);
      }
    };

    fetchSavedReports();
  }, [userId]);

  // Save reports to localStorage
  useEffect(() => {
    localStorage.setItem('savedLeadReports', JSON.stringify(savedReports));
  }, [savedReports]);
  
  // Fetch data from API
  // useEffect(() => {
  //   const fetchLeads = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await axios.get(`${baseURL}/api/allleads`);
  //       // Filter only "lead" status data
  //       const leadsOnly = response.data.filter(item => item.status == 'lead' && item.assignedSalesId == userId);
  //       setRawData(leadsOnly);  // Store only filtered data
  //       setFilteredData(leadsOnly);  // Also set filtered data
  //     } catch (error) {
  //       message.error('Failed to fetch leads');
  //       console.error('Error fetching leads:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchLeads();
  // }, []);


  const {
    data: leadsData = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['sales-leads-only', userId],
    refetchInterval: 3000, 
    queryFn: async () => {
      console.log("Fetching for userId:", userId); 
      try {
        const response = await axios.get(`${baseURL}/api/allleads-employee-report/${userId}`);
        console.log("API Response:", response.data); 
        console.log("Response data:", response.data.data); 
        return response.data.data; 
      } catch (err) {
        console.error("API Error:", err);
        throw err;
      }
    },
    enabled: !!userId,
    keepPreviousData: true,
  });

const fetchCommentCounts = useCallback(async (leads) => {
  if (!leads || leads.length === 0) return;

  const leadIds = leads.map(l => l.leadid);

  try {
    const response = await axios.post(`${baseURL}/comments/bulk-counts`, { leadIds });
    const { counts, dates } = response.data;

    // Convert date strings to Date objects
    const parsedDates = {};
    Object.keys(dates).forEach(id => {
      parsedDates[id] = dates[id]
        .map(d => new Date(d))
        .filter(d => !isNaN(d.getTime()));
    });

    setCommentCounts(prev => {
      const hasChanged = Object.keys(counts).some(k => prev[k] !== counts[k]);
      return hasChanged ? { ...prev, ...counts } : prev;
    });
    setCommentDates(prev => ({ ...prev, ...parsedDates }));

  } catch (error) {
    console.error('Bulk comment fetch failed:', error);
  }
}, [baseURL]);

  useEffect(() => {
    if (leadsData && leadsData.length > 0) {
      setRawData(leadsData);
      setFilteredData(leadsData);
      fetchCommentCounts(leadsData); 
    }
  }, [leadsData]);

  // Add modal handlers


  console.log("leadsData in component:", leadsData);
  
  useEffect(() => {
    const filtered = applyFilters(rawData);
    setFilteredData(filtered);
  }, [selectedFields, activeFilters, rawData,commentDates]);

  // Update generateColumns function with Indian date format and comment button
  const generateColumns = () => {
    return selectedFields.map(fieldKey => {
      const field = allFields.find(f => f.key == fieldKey);
      

         if (fieldKey === 'name') {
  return {
    title: field.label,
    dataIndex: fieldKey,
    key: fieldKey,
    width: 80,
    fixed: selectedFields.indexOf(fieldKey) === 0 ? 'left' : false,
    sorter: (a, b) => String(a[fieldKey] || '').localeCompare(String(b[fieldKey] || '')),
    ellipsis: true,
    render: (value, record) => (
      <span
 style={{ 
      color: '#1890ff', 
      cursor: 'pointer', 
      textDecoration: 'underline',
      textDecorationColor: '#1890ff',   
      textUnderlineOffset: '4px'       
    }}
            onClick={() => {
          setSelectedLeadForComments(record);   
          setShowCommentsModal(true);           
        }}
      >
        {value || '-'}
      </span>
    ),
  };
}
      // Special handling for comment column
      if (fieldKey === 'comment') {
        return {
          title: field.label,
          key: 'comment_action',
          width: 120,
          fixed: selectedFields.indexOf(fieldKey) === 0 ? 'left' : false,
          sorter: (a, b) => {
            // Sort by comment count
            const countA = commentCounts[a.leadid] || 0;
            const countB = commentCounts[b.leadid] || 0;
            return countA - countB;
          },
          render: (_, record) => {
            const commentCount = commentCounts[record.leadid] || 0;
            
            return (
              <Button
                type="primary"
                size="small"
                disabled={commentCount === 0}
                onClick={() => {
                  setSelectedLeadForComments(record);
                  setShowCommentsModal(true);
                }}
                style={{ 
                  backgroundColor: commentCount > 0 ? "#ff9966" : "#d9d9d9",
                  borderColor: commentCount > 0 ? "#ff9966" : "#d9d9d9",
                  width: '100px'
                }}
              >
                {commentCount > 0 
                  ? `${commentCount} Comment${commentCount > 1 ? 's' : ''}` 
                  : 'No Comments'}
              </Button>
            );
          },
          onHeaderCell: () => ({
            style: { 
              width: 120,
              minWidth: 120,
              maxWidth: 120,
              whiteSpace: 'nowrap'
            }
          }),
          onCell: () => ({
            style: { 
              width: 120,
              minWidth: 120,
              maxWidth: 120,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          })
        };
      }
      
      // Regular field handling with Indian date format
      const renderValue = (value) => {
        if (!value) return '-';
        
        // Format dates in Indian format (DD/MM/YYYY HH:MM:SS)
        if (fieldKey === 'created_at' || fieldKey === 'updated_at') {
          const date = new Date(value);
          if (isNaN(date.getTime())) return value; 
          
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          const hours = date.getHours().toString().padStart(2, '0');
          const minutes = date.getMinutes().toString().padStart(2, '0');
          const seconds = date.getSeconds().toString().padStart(2, '0');
          
          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        }
        
        // Handle tag_names array
        if (fieldKey === 'tag_names' && Array.isArray(value)) {
          return value.join(', ');
        }
        
        return value || '-';
      };
      
      // Set column widths
      let width = 150; // default width
      if (fieldKey === 'name') width = 200;
      if (fieldKey === 'email') width = 220;
      if (fieldKey === 'phone_number') width = 130;
      if (fieldKey === 'leadid') width = 100;
      if (fieldKey === 'status' || fieldKey === 'primaryStatus' || fieldKey === 'secondaryStatus') width = 140;
      if (fieldKey === 'primarySource' || fieldKey === 'secondarysource') width = 160;
      if (fieldKey === 'destination') width = 120;
                      if ([ 'origincity'].includes(fieldKey)) width = 120;

      if (fieldKey === 'created_at' || fieldKey === 'updated_at') width = 180;
      if (fieldKey === 'tag_names') width = 200;
      
      return {
        title: field.label,
        dataIndex: fieldKey,
        key: fieldKey,
        width: width,
        fixed: selectedFields.indexOf(fieldKey) === 0 ? 'left' : false,
        sorter: (a, b) => {
          if (field.type === 'number') return (a[fieldKey] || 0) - (b[fieldKey] || 0);
          if (fieldKey === 'created_at' || fieldKey === 'updated_at') {
            return new Date(a[fieldKey] || 0) - new Date(b[fieldKey] || 0);
          }
          if (fieldKey === 'tag_names' && Array.isArray(a[fieldKey]) && Array.isArray(b[fieldKey])) {
            return (a[fieldKey].join(', ') || '').localeCompare(b[fieldKey].join(', ') || '');
          }
          return String(a[fieldKey] || '').localeCompare(String(b[fieldKey] || ''));
        },
        render: renderValue,
        ellipsis: true,
        onHeaderCell: () => ({
          style: { 
            width: width,
            minWidth: width,
            maxWidth: width,
            whiteSpace: 'nowrap'
          }
        }),
        onCell: () => ({
          style: { 
            width: width,
            minWidth: width,
            maxWidth: width,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        })
      };
    });
  };


    const handleCloseCommentsModal = useCallback(() => {
      setShowCommentsModal(false);
      setSelectedLeadForComments(null);
      if (rawData && rawData.length > 0) {
        fetchCommentCounts(rawData);
      }
    }, [rawData]);
    
    const handleCommentsModalHide = useCallback(() => {
      handleCloseCommentsModal();
    }, [handleCloseCommentsModal]);


  const applyFilters = (data) => {
    if (!data || data.length == 0) return [];

    let filteredData = [...data];

    activeFilters.forEach(filter => {
      const { field, value } = filter;

      if (field.type == 'text') {
        if (value && value.length > 0) {
          filteredData = filteredData.filter(item => {
            const itemValue = item[field.key] || '';
            return value.some(val =>
              String(itemValue).toLowerCase().includes(String(val).toLowerCase())
            );
          });
        }
      }
      else if (field.type == 'number') {
        if (value?.min !== undefined && value?.min !== null) {
          filteredData = filteredData.filter(item => (item[field.key] || 0) >= value.min);
        }
        if (value?.max !== undefined && value?.max !== null) {
          filteredData = filteredData.filter(item => (item[field.key] || 0) <= value.max);
        }
      }


         else if (field.key === 'comment' && field.type === 'date' && value && value.length === 2) {
      const [startDateTime, endDateTime] = value;
  const start = startDateTime
  ? new Date(typeof startDateTime.valueOf === 'function' ? startDateTime.valueOf() : startDateTime)
  : null;
const end = endDateTime
  ? new Date(typeof endDateTime.valueOf === 'function' ? endDateTime.valueOf() : endDateTime)
  : null;
      if (end) { end.setSeconds(59); end.setMilliseconds(999); }

      filteredData = filteredData.filter(item => {
        const leadCommentDates = commentDates[item.leadid] || [];
        if (leadCommentDates.length === 0) return false;
        return leadCommentDates.some(commentDate => {
          if (!commentDate || isNaN(commentDate)) return false;
          if (start && end) return commentDate >= start && commentDate <= end;
          if (start) return commentDate >= start;
          if (end) return commentDate <= end;
          return true;
        });
      });
    }
      else if (field.type == 'date' && value && value.length == 2) {
        const [startDateTime, endDateTime] = value;
        
        const start = startDateTime ? new Date(startDateTime) : null;
        const end = endDateTime ? new Date(endDateTime) : null;
        
        if (end) {
          end.setSeconds(59);
          end.setMilliseconds(999);
        }
        
        filteredData = filteredData.filter(item => {
          const itemDate = item[field.key] ? new Date(item[field.key]) : null;
          
          if (!itemDate) return false;
          
          if (start && end) {
            return itemDate >= start && itemDate <= end;
          } else if (start) {
            return itemDate >= start;
          } else if (end) {
            return itemDate <= end;
          }
          return true;
        });
      }
    });

    return filteredData;
  };

  const {
    data: tags = [],
    isLoading: tagsLoading
  } = useQuery({
    queryKey: ['tags'],
    queryFn: async () => {
      const response = await axios.get(`${baseURL}/api/tags`);
      return response.data;
    },
    keepPreviousData: true,
  });
  
  // Update filter components with tag handling
  const filterComponents = {
    text: ({ field, value, onChange, onRemove }) => {
      // Special handling for tag_names field
      if (field.key === 'tag_names') {
        return (
          <Select
            mode="multiple"
            style={{ width: 250 }}
            placeholder="Select tags"
            value={value}
            onChange={onChange}
            loading={tagsLoading}
            allowClear
            options={tags.map(tag => ({
              value: tag.value,
              label: tag.label
            }))}
          />
        );
      }
      
      // Regular text field handling
      const uniqueValues = [...new Set(rawData.map(item => item[field.key]))];
      return (
        <Select
          mode="multiple"
          style={{ width: 200 }}
          placeholder={`Select ${field.label}`}
          value={value}
          onChange={onChange}
          dropdownRender={menu => (
            <div>
              {menu}
              <div style={{ padding: '5px', textAlign: 'right' }}>
                <Button size="small" danger onClick={onRemove}>
                  Remove Filter
                </Button>
              </div>
            </div>
          )}
        >
          {uniqueValues.map(val => (
            <Option key={val} value={val}>{val || '(Empty)'}</Option>
          ))}
        </Select>
      );
    },
    number: ({ field, value, onChange, onRemove }) => (
      <Space>
        <InputNumber
          placeholder={`Min ${field.label}`}
          value={value?.min}
          onChange={min => onChange({ ...value, min })}
          style={{ width: 100 }}
        />
        <InputNumber
          placeholder={`Max ${field.label}`}
          value={value?.max}
          onChange={max => onChange({ ...value, max })}
          style={{ width: 100 }}
        />
        <Button danger icon={<CloseOutlined />} onClick={onRemove} />
      </Space>
    ),
    date: ({ field, value, onChange, onRemove }) => (
      <Space direction="vertical" size="small">
        <RangePicker
          value={value}
          onChange={onChange}
          format="YYYY-MM-DD HH:mm"
          showTime={{ format: 'HH:mm' }}
          placeholder={['Start Date & Time', 'End Date & Time']}
        />
        <Button danger icon={<CloseOutlined />} onClick={onRemove} size="small">
          Remove Filter
        </Button>
      </Space>
    )
  };

  // Generate filtered data when fields or filters change
  useEffect(() => {
    const available = allFields
      .filter(field => !activeFilters.some(f => f.field.key == field.key));
    setAvailableFilterFields(available);
    setSelectedFilterField(available[0]?.key || null);
  }, [activeFilters]);

  // Handler functions
  const handleFieldChange = (values) => setSelectedFields(values);

  const addFilter = () => {
    if (!selectedFilterField) return;
    const field = allFields.find(f => f.key == selectedFilterField);
    if (!field) return;
    const newFilter = {
      id: Date.now(),
      field,
      value: field.type == 'number' ? { min: null, max: null } :
        field.type == 'date' ? null : []
    };
    setActiveFilters([...activeFilters, newFilter]);
  };

  const updateFilter = (id, newValue) => {
    setActiveFilters(activeFilters.map(filter =>
      filter.id == id ? { ...filter, value: newValue } : filter
    ));
  };

  const removeFilter = (id) => {
    setActiveFilters(activeFilters.filter(filter => filter.id !== id));
  };

  // Update exportToExcel with Indian date format
  const exportToExcel = async ()  => {
    const exportData = filteredData.map(item => {
      const row = {};
      selectedFields.forEach(field => {
        const fieldInfo = allFields.find(f => f.key == field);
        const label = fieldInfo?.label || field;
        
        // Format dates in Indian format for Excel export
        if (field === 'created_at' || field === 'updated_at') {
          const date = new Date(item[field]);
          if (!isNaN(date.getTime())) {
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            row[label] = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
          } else {
            row[label] = item[field] || '';
          }
        } else if (field === 'tag_names') {
        const tagVal = item[field];
        row[label] = Array.isArray(tagVal) ? tagVal.join(', ') : (tagVal || '');
      }
      else if (field === 'comment') {
        const count = commentCounts[item.leadid] || 0;
        row[label] = count > 0 ? `${count} Comment${count > 1 ? 's' : ''}` : 'No Comments';
      }  else {
        row[label] = item[field] || '';
      }
      });
      return row;
    });

    const commentRows = [];

  try {
    const allLeadIds = filteredData.map(l => l.leadid);

    const response = await axios.post(`${baseURL}/comments/bulk-counts`, { leadIds: allLeadIds });
    const { comments } = response.data;

    const leadMap = {};
    filteredData.forEach(item => {
      leadMap[item.leadid] = item.name || '-';
    });

    Object.keys(comments).forEach(leadId => {
      const leadComments = comments[leadId];
      if (!leadComments || leadComments.length === 0) return;

      leadComments.forEach(({ date, text }) => {
        const d = new Date(date);
        if (isNaN(d.getTime())) return;

        const day     = d.getDate().toString().padStart(2, '0');
        const month   = (d.getMonth() + 1).toString().padStart(2, '0');
        const year    = d.getFullYear();
        const hours   = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const seconds = d.getSeconds().toString().padStart(2, '0');

        commentRows.push({
          'Lead ID':      leadId,
          'Lead Name':    leadMap[leadId] || '-',
          'Comment Date': `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`,
          'Comment':      text || '-',
        });
      });
    });

    // Sort by Lead ID then by date ascending
    commentRows.sort((a, b) => {
      if (String(a['Lead ID']) !== String(b['Lead ID']))
        return String(a['Lead ID']).localeCompare(String(b['Lead ID']));
      return new Date(a['Comment Date']) - new Date(b['Comment Date']);
    });

  } catch (error) {
    console.error('Failed to fetch comment data for export:', error);
  }

  // ── Build workbook with 2 sheets ──────────────────────────────────────
  const workbook = XLSX.utils.book_new();

  const ws1 = XLSX.utils.json_to_sheet(exportData);
  XLSX.utils.book_append_sheet(workbook, ws1, 'Leads Report');

  const ws2 = XLSX.utils.json_to_sheet(
    commentRows.length > 0
      ? commentRows
      : [{ 'Lead ID': '', 'Lead Name': 'No comments found', 'Comment Date': '', 'Comment': '' }]
  );
  XLSX.utils.book_append_sheet(workbook, ws2, 'Comment Details');

  XLSX.writeFile(workbook, 'leads_report.xlsx');
};

  const showSaveModal = () => setIsSaveModalVisible(true);

  const toggleSavedReports = () => setShowSavedReports(!showSavedReports);

  const saveReportToBoth = async (report) => {
    try {
      const response = await axios.post(`${baseURL}/api/reports`, report);
      const newReport = response.data;

      setSavedReports(prev => {
        const updatedReports = [...prev, newReport];
        localStorage.setItem('savedLeadReports', JSON.stringify(updatedReports));
        return updatedReports;
      });

      return newReport;
    } catch (error) {
      console.error('Error saving report to API:', error);
      const newReport = {
        ...report,
        id: Date.now(),
        createdAt: new Date().toISOString()
      };

      setSavedReports(prev => {
        const updatedReports = [...prev, newReport];
        localStorage.setItem('savedLeadReports', JSON.stringify(updatedReports));
        return updatedReports;
      });

      return newReport;
    }
  };

  const deleteReportFromBoth = async (reportId) => {
    try {
      await axios.delete(`${baseURL}/api/reports/${reportId}`);
    } catch (error) {
      console.error('Error deleting report from API:', error);
    }

    setSavedReports(prev => {
      const updatedReports = prev.filter(report => report.id !== reportId);
      localStorage.setItem('savedLeadReports', JSON.stringify(updatedReports));
      return updatedReports;
    });
  };

  const handleSaveReport = async () => {
    if (!reportName.trim()) {
      message.error('Please enter a report name');
      return;
    }

    try {
      const newReport = {
        name: reportName,
        description: reportDescription,
        selectedFields: [...selectedFields],
        activeFilters: [...activeFilters],
        userId: userId,
        type: "Lead"
      };

      await saveReportToBoth(newReport);

      setIsSaveModalVisible(false);
      setReportName('');
      setReportDescription('');
      message.success('Report saved successfully');
      setShowSavedReports(true); // Show saved reports after saving
    } catch (error) {
      message.error('Failed to save report');
      console.error('Error saving report:', error);
    }
  };

  const deleteReport = async (reportId, e) => {
    e.stopPropagation();
    try {
      await deleteReportFromBoth(reportId);
      if (selectedReport == reportId) {
        setSelectedReport(null);
      }
      message.success('Report deleted');
    } catch (error) {
      message.error('Failed to delete report');
      console.error('Error deleting report:', error);
    }
  };

const loadReport = (report) => {
  const restoredFilters = report.activeFilters.map(filter => {
    if (filter.field.type === 'date') {
      const restoredValue = Array.isArray(filter.value) && filter.value.length === 2
        ? [
            filter.value[0] ? dayjs(filter.value[0]) : null,
            filter.value[1] ? dayjs(filter.value[1]) : null,
          ]
        : null;
      return { ...filter, value: restoredValue };
    }
    return filter;
  });
  setSelectedFields(report.selectedFields);
  setActiveFilters(restoredFilters);
  setSelectedReport(report.id);
  message.info(`Loaded report: ${report.name}`);
  setShowSavedReports(false);
};

  return (
    <div className="Admin-reportcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Admin-report ${collapsed ? "collapsed" : ""}`}>
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

          <div className="payments-tabs">
            <button
              className={activeTab == "reportleads" ? "active" : ""}
              onClick={() => {
                setActiveTab("reportleads");
              }}
            >
              Leads
            </button>
            <button
              className={activeTab == "reportopp" ? "active" : ""}
              onClick={() => {
                setActiveTab("reportopp")
                navigate(`/S_Report_opp/`);
              }}
            >
              Opportunity
            </button>
          </div>
          <Card style={{ padding: '16px', margin: '16px 0', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', backgroundColor: 'rgba(163, 110, 41, 0.08)' }}>
                 
          <div><h3 className='text-center'>Reports</h3></div>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '16px',
            gap: '16px',
            flexWrap: 'nowrap' // Change to nowrap for better layout
          }}>
            {/* LEFT SECTION - Dropdown and Tags */}
            <div style={{ display: "flex", gap: "10px" }}>
              {/* LEFT DROPDOWN */}
              <Select
                mode="multiple"
                placeholder="Select fields"
                value={selectedFields.length ? selectedFields : undefined}
                onChange={handleFieldChange}
                tagRender={() => null}
                style={{
                  width: "350px",
                  height: "34px"
                }}
              >
                {allFields.map(field => (
                  <Option key={field.key} value={field.key}>
                    {field.label}
                  </Option>
                ))}
              </Select>

              {/* FIXED WIDTH SCROLLABLE TAG FIELD */}
              <div
                style={{
                  width: "420px",
                  overflowX: "auto",
                  scrollbarWidth: "thin"
                }}
              >
                <div
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    height: "34px",
                    padding: "4px 10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    whiteSpace: "nowrap",
                    minWidth: "max-content"
                  }}
                >
                  {selectedFields.map(key => {
                    const field = allFields.find(f => f.key === key);
                    return (
                      <Tag
                        key={key}
                        closable
                        style={{
                          fontSize: "14px",
                          padding: "2px 10px",
                          margin: 0
                        }}
                        onClose={() =>
                          setSelectedFields(selectedFields.filter(f => f !== key))
                        }
                      >
                        {field?.label}
                      </Tag>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* RIGHT BUTTONS */}
            <Space>
              <Button onClick={exportToExcel} type="primary">
                Export to Excel
              </Button>
              <Button onClick={showSaveModal}>
                Save Report
              </Button>
              <Button onClick={toggleSavedReports}>
                {showSavedReports ? 'Hide Saved' : 'Show Saved'}
              </Button>
            </Space>
          </div>

          {/* Filters row with horizontal scroll */}
          <div style={{
            marginBottom: '16px',
            padding: '12px',
            backgroundColor: '#fafafa',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            overflowX: 'auto',
            whiteSpace: 'nowrap'
          }}>
            <Space size="middle">
              {activeFilters.length > 0 ? (
                activeFilters.map(filter => {
                  const FilterComponent = filterComponents[filter.field.type];
                  return (
                    <div key={filter.id} style={{
                      display: 'inline-block',
                      padding: '8px',
                      border: '1px solid #d9d9d9',
                      borderRadius: '4px',
                      backgroundColor: 'white'
                    }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                        {filter.field.label}
                      </div>
                      <FilterComponent
                        field={filter.field}
                        value={filter.value}
                        onChange={(value) => updateFilter(filter.id, value)}
                        onRemove={() => removeFilter(filter.id)}
                      />
                    </div>
                  );
                })
              ) : (
                <span style={{ color: '#999' }}>No filters applied</span>
              )}
            </Space>

            <div style={{ display: 'inline-block', marginLeft: '16px', verticalAlign: 'top' }}>
              <Space>
                <Select
                  style={{ width: 200 }}
                  value={selectedFilterField}
                  onChange={setSelectedFilterField}
                  disabled={availableFilterFields.length == 0}
                >
                  {availableFilterFields.map(field => (
                    <Option key={field.key} value={field.key}>{field.label}</Option>
                  ))}
                </Select>

                <Button
                  type="primary"
                  onClick={addFilter}
                  disabled={availableFilterFields.length == 0}
                >
                  Add Filter
                </Button>

                {activeFilters.length > 0 && (
                  <Button
                    danger
                    onClick={() => setActiveFilters([])}
                  >
                    Clear All
                  </Button>
                )}
              </Space>
            </div>
          </div>

          {/* Main content area */}
          <div style={{ overflowX: 'auto' }}>
            <div style={{
              display: 'flex',
              flex: 1,
              gap: '16px',
              minWidth: '1000px'
            }}>
              {/* Lead Report Table */}
              <div style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minWidth: 0
              }}>
                <div style={{ marginBottom: '8px' }}>
                  <h3>Lead Report ({filteredData.length} records)</h3>
                </div>
                <div style={{ flex: 1 }}>
                  <Spin spinning={isLoading}>
                    <Table
                      columns={generateColumns()}
                      dataSource={filteredData}
                      rowKey="leadid"
                      pagination={{ pageSize: 10 }}
                      bordered
                      scroll={{ x: 'max-content', y: '100%' }}
                      style={{ minWidth: '100%' }}
                    />
                  </Spin>
                </div>
              </div>

              {/* Saved Reports Sidebar */}
              {showSavedReports && (
                <div style={{
                  width: '300px',
                  borderLeft: '1px solid #d9d9d9',
                  paddingLeft: '16px',
                  overflowY: 'auto'
                }}>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px'
                  }}>
                    <h3>Saved Reports</h3>
                    <Button
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => setShowSavedReports(false)}
                    />
                  </div>

                  {savedReports.length == 0 ? (
                    <p>No saved reports yet</p>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                      {savedReports.map(report => (
                        <Card
                          key={report.id}
                          onClick={() => loadReport(report)}
                          size="small"
                          style={{
                            cursor: 'pointer',
                            borderColor: selectedReport == report.id ? '#1890ff' : '#d9d9d9',
                            backgroundColor: selectedReport == report.id ? '#e6f7ff' : 'white'
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flex: 1, overflow: 'hidden' }}>
                              <h4 style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                margin: 0
                              }}>
                                {report.name}
                              </h4>
                              <p style={{ color: '#666', fontSize: '12px', margin: '4px 0' }}>
                                {new Date(report.created_at).toLocaleString()}
                              </p>
                              {report.description && (
                                <p style={{
                                  fontSize: '12px',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  margin: 0
                                }}>
                                  {report.description}
                                </p>
                              )}
                              <div style={{ marginTop: '4px' }}>
                                <Tag color="blue" style={{ marginRight: 0 }}>{report.selectedFields.length} cols</Tag>
                                <Tag color="orange">{report.activeFilters.length} filters</Tag>
                              </div>
                            </div>
                            <Button
                              danger
                              size="small"
                              onClick={(e) => deleteReport(report.id, e)}
                              style={{ marginLeft: '8px' }}
                            >
                              Delete
                            </Button>
                          </div>
                        </Card>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          </Card>
        </div>

        {/* Save Report Modal */}
        <Modal
          title="Save Report Configuration"
          open={isSaveModalVisible}
          onOk={handleSaveReport}
          onCancel={() => setIsSaveModalVisible(false)}
          width={700}
        >
          <Form layout="vertical">
            <Form.Item label="Report Name" required>
              <Input
                value={reportName}
                onChange={(e) => setReportName(e.target.value)}
                placeholder="Enter report name"
              />
            </Form.Item>
            <Form.Item label="Description">
              <Input.TextArea
                value={reportDescription}
                onChange={(e) => setReportDescription(e.target.value)}
                placeholder="Enter description (optional)"
                rows={3}
              />
            </Form.Item>
            <Form.Item label="Selected Fields">
              <div style={{
                padding: '10px',
                background: '#f5f5f5',
                borderRadius: '4px',
                maxHeight: '150px',
                overflowY: 'auto'
              }}>
                {selectedFields.map(field => {
                  const fieldInfo = allFields.find(f => f.key == field);
                  return <div key={field}>{fieldInfo.label}</div>;
                })}
              </div>
            </Form.Item>
            <Form.Item label="Active Filters">
              <div style={{
                padding: '10px',
                background: '#f5f5f5',
                borderRadius: '4px',
                maxHeight: '150px',
                overflowY: 'auto'
              }}>
                {activeFilters.length == 0 ? (
                  <div>No active filters</div>
                ) : (
                  activeFilters.map(filter => (
                    <div key={filter.id} style={{ marginBottom: '5px' }}>
                      <strong>{filter.field.label}: </strong>
                      {filter.field.type == 'text' && filter.value.join(', ')}
                      {filter.field.type == 'number' && [
                        filter.value.min && `Min: ${filter.value.min}`,
                        filter.value.max && `Max: ${filter.value.max}`
                      ].filter(Boolean).join(' | ')}
                  {filter.field.type == 'date' && filter.value && Array.isArray(filter.value) &&
  `${filter.value[0] ? (typeof filter.value[0].format === 'function' ? filter.value[0].format('YYYY-MM-DD HH:mm') : new Date(filter.value[0]).toISOString().slice(0, 16).replace('T', ' ')) : ''} to ${filter.value[1] ? (typeof filter.value[1].format === 'function' ? filter.value[1].format('YYYY-MM-DD HH:mm') : new Date(filter.value[1]).toISOString().slice(0, 16).replace('T', ' ')) : ''}`
}
                    </div>
                  ))
                )}
              </div>
            </Form.Item>
          </Form>
        </Modal>
      </div>
      
       <ReportComments
  show={showCommentsModal}
  onHide={handleCommentsModalHide}
  selectedLead={selectedLeadForComments}
  baseURL={baseURL}
  selectedFields={selectedFields}  
  allFields={allFields}             
/>
    </div>
  );
};

export default S_ReportBuilder;